angular.module('nv.my-supports').component('mySupportsList', {
  template: require('./my-supports-list.html'),
  bindings: {
    activeSupportsForCurrentUser: '<',
  },
  controller: 'MySupportsListCtrl',
});
